angular.module("ainapp")
    .controller("addEmployeeSalaryController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Add Employee Salary";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.basePath = config.basePath;

            $scope.Employees = [];
            MainService.EmployeesInDropdown().then(function (response) {
                $scope.Employees = response.data;
            })

            $scope.PayrollSettings = {};
            MainService.GetPayrollSettings().then(function (response) {
                $scope.PayrollSettings = response.data;
            })

            $scope.loadVoucher = function (data) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetEmployeeSalary(data).then(function (response) {
                    if (response.data != null) {
                        $scope.addData = response.data;
                        $scope.addData.Date = new Date($scope.addData.Date);
                    } else {
                        toastr.error($scope.LanguageData.NetworkError);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error($scope.LanguageData.NetworkError);
                    $.LoadingOverlay("hide");
                });
            }


            $scope.Init = function () {

                var date = new Date();
                var year = date.getFullYear();
                var month = date.getMonth();
                $scope.monthNo = month + 1;
                var monthName = $scope.MonthsArr[month].Name;

                var d = new Date(year, $scope.monthNo, 0).getDate();

                $scope.ViewVal = 0;

                $scope.addData = {
                    VoucherNumber: "",
                    Date: new Date(),
                    Remarks: "",
                    Year: year,
                    Month: monthName,
                    EmployeeId: "",
                    NetSalary: 0,
                    OvertimeSalary: 0,
                    TotalDeductions: 0,
                    TotalSalary: 0,
                    MonthDays: d,
                    DaysAttended: 0,
                    PaidLeavs: 0,
                    WeeklyOff: 0,
                    Holidays: 0,
                    LOP: 0,
                    OvertimeHours: 0,
                    LateHourDeduction: 0,
                    LateHours: 0,
                    EffectiveDays: 0,
                    HolidayHours: 0,
                    HolidayValue: 0,
                    WeekOffHours: 0,
                    WeekOffValue: 0,
                    EmployeeSalaryDetails: [],
                }

                $scope.PayrollComponents = [];
                $scope.PayrollComponents2 = [];
                MainService.PayrollComponentsInSalary().then(function (response) {
                    $scope.PayrollComponents = response.data;
                    angular.forEach($scope.PayrollComponents, function (e) {

                        var detail = {
                            Type: e.Type,
                            PayrollComponentId: e.Id,
                            PayrollComponent: e,
                            Actual: 0,
                            Calculated: 0,
                            Arrears: 0,
                            Adjustments: 0,
                        }
                        $scope.addData.EmployeeSalaryDetails.push(detail);

                    })
                    $scope.PayrollComponents2 = angular.copy($scope.addData.EmployeeSalaryDetails);
                })

                if ($stateParams.VoucherId > 0) {
                    $scope.loadVoucher($stateParams.VoucherId);
                } else {
                    MainService.GetNextEmployeeSalaryNo().then(function (response) {
                        $scope.addData.VoucherNumber = response.data;
                    })
                }



            }
            $scope.Init();

            $scope.getEmployeeDetails = function () {

                angular.forEach($scope.MonthsArr2, function (e) {
                    if ($scope.addData.Month == e.Name) {
                        $scope.monthNo = e.Id;
                        $scope.monthName = e.Name;
                    }
                })

                var d = new Date($scope.addData.Year, $scope.monthNo, 0).getDate();
                $scope.addData.MonthDays = d;

                if ($scope.addData.EmployeeId > 0) {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.CheckEmployeeSalaryByDate($scope.addData.Year, $scope.addData.Month, $scope.addData.EmployeeId).then(function (response) {
                            if (response.data > 0) {

                                $scope.loadVoucher(response.data);

                            } else {

                                $.LoadingOverlay("show", {
                                    image: "images/load.gif",
                                });

                                $scope.addData.EmployeeSalaryDetails = angular.copy($scope.PayrollComponents2);

                                $scope.addData.NetSalary = 0;
                                $scope.addData.LateHourDeduction = 0;
                                $scope.addData.TotalDeductions = 0;
                                $scope.addData.TotalSalary = 0;
                                $scope.addData.TotalDeductions = 0;
                                $scope.addData.OvertimeSalary = 0;
                                $scope.addData.OvertimeHours = 0;
                                $scope.addData.LateHours = 0;
                                $scope.addData.PaidLeavs = 0;
                                $scope.addData.WeeklyOff = 0;
                                $scope.addData.Holidays = 0;
                                $scope.addData.LOP = 0;
                                $scope.addData.EffectiveDays = 0;
                                $scope.addData.HolidayHours = 0;
                                $scope.addData.HolidayValue = 0;
                                $scope.addData.WeekOffHours = 0;
                                $scope.addData.WeekOffValue = 0;

                                MainService.GeEmployeePayrollById($scope.addData.EmployeeId).then(function (response3) {
                                    if (response3.data) {

                                        $scope.AttandanceSummary = response3.data;
                                        var basicsalary = response3.data.BasicSalary;
                                        var netSalary = response3.data.NetSalary;

                                        angular.forEach($scope.addData.EmployeeSalaryDetails, function (e) {
                                            angular.forEach(response3.data.EmployeePayrolls, function (a) {
                                                if (a.PayrollComponentId == e.PayrollComponentId) {
                                                    e.Actual = a.Amount;
                                                    e.Calculated = a.Amount;
                                                }
                                            })
                                        })

                                        $.LoadingOverlay("show", {
                                            image: "images/load.gif",
                                        });
                                        MainService.GetEmployeeSalaryValues($scope.addData.EmployeeId, $scope.addData.Year, $scope.monthNo, $scope.monthName)
                                            .then(function (response2) {
                                                if (response2.data) {

                                                    $scope.AttandanceSummary = response2.data;

                                                    $scope.addData.OvertimeHours = response2.data.OverTimeHours;
                                                    $scope.addData.LateHours = Math.abs(response2.data.LateHours);

                                                    $scope.addData.WeeklyOff = response2.data.TotalWeekOffs;
                                                    $scope.addData.Holidays = response2.data.TotalHolidays;
                                                    $scope.addData.DaysAttended = response2.data.TotalAttendedDays;

                                                    $scope.addData.HolidayHours = response2.data.HolidayHours;
                                                    $scope.addData.WeekOffHours = response2.data.WeekOffHours;

                                                    $scope.addData.WeekOffValue = response2.data.WeekOffHours * response2.data.SpecialOvertimeValue;
                                                    $scope.addData.WeekOffValue = Math.round($scope.addData.WeekOffValue * 100) / 100;

                                                    $scope.addData.HolidayValue = response2.data.HolidayHours * response2.data.HolidayOvertimeValue;
                                                    $scope.addData.HolidayValue = Math.round($scope.addData.HolidayValue * 100) / 100;


                                                    var daysalary = 0;
                                                    var hoursalary = 0;

                                                    if ($scope.addData.OvertimeHours > 0) {

                                                        var whrs = $scope.PayrollSettings.DefaultWorkingHours;
                                                        var days = $scope.addData.MonthDays;

                                                        var totalearning = 0;
                                                        angular.forEach($scope.addData.EmployeeSalaryDetails, function (e) {
                                                            if (e.Type == "Earnings") {
                                                                totalearning = totalearning + e.Calculated;
                                                            }

                                                        })
                                                        daysalary = totalearning / days;
                                                        hoursalary = daysalary / whrs;

                                                        if ($scope.PayrollSettings.OvertimePayType == "Fixed") {

                                                            $scope.addData.OvertimeSalary = $scope.addData.OvertimeHours * $scope.PayrollSettings.OvertimeValue;

                                                        } else if ($scope.PayrollSettings.OvertimePayType == "WorkHour") {

                                                            $scope.addData.OvertimeSalary = $scope.addData.OvertimeHours * hoursalary;

                                                        } else if ($scope.PayrollSettings.OvertimePayType == "Percentage") {

                                                            var per = hoursalary * ($scope.PayrollSettings.OvertimeValue / 100);
                                                            per = Math.round(per * 100) / 100;

                                                            $scope.addData.OvertimeSalary = $scope.addData.OvertimeHours * (hoursalary + per);
                                                        }

                                                        $scope.addData.LateHourDeduction = $scope.addData.LateHours * 10;

                                                    }

                                                    $scope.addData.PaidLeavs = response2.data.TotalPaidLeaves;
                                                    $scope.addData.LOP = response2.data.TotalUnPaidLeaves;

                                                    angular.forEach($scope.addData.EmployeeSalaryDetails, function (e) {
                                                        angular.forEach(response2.data.EmployeeLeaveLogs, function (a) {
                                                            if (e.PayrollComponentId == a.PayrollComponentId) {

                                                                var ded = a.Count * daysalary;
                                                                var val = Math.round(ded * 100) / 100;
                                                                e.Actual = val;
                                                                e.Calculated = val;
                                                                e.Arrears = 0;
                                                                e.Adjustments = 0;

                                                            }
                                                        })
                                                    })


                                                    angular.forEach($scope.addData.EmployeeSalaryDetails, function (e) {
                                                        angular.forEach(response2.data.EarningDeductionDetails, function (a) {
                                                            if (e.PayrollComponentId == a.PayrollComponentId) {
                                                                e.Actual = a.Amount;
                                                                e.Calculated = a.Amount;
                                                                e.Arrears = 0;
                                                                e.Adjustments = 0;
                                                            }
                                                        })
                                                    })

                                                    angular.forEach($scope.addData.EmployeeSalaryDetails, function (e) {
                                                        angular.forEach(response2.data.EmployeeLoanDetails, function (a) {
                                                            if (e.PayrollComponentId == a.EmployeeLoan.LoanTypeId) {
                                                                e.Actual = a.Amount;
                                                                e.Calculated = a.Amount;
                                                                e.Arrears = 0;
                                                                e.Adjustments = 0;
                                                            }
                                                        })

                                                    })


                                                          $scope.addData.EffectiveDays = $scope.addData.DaysAttended;
                                                    // $scope.addData.EffectiveDays = $scope.addData.DaysAttended + $scope.addData.PaidLeavs +
                                                    //     $scope.addData.WeeklyOff + $scope.addData.Holidays;
                                                    $scope.calculateSalary();



                                                }
                                                $.LoadingOverlay("hide");
                                            }, function (err) {
                                                toastr.error($scope.LanguageData.NetworkError);
                                                $.LoadingOverlay("hide");
                                            });

                                        $scope.calculateSalary();

                                    }
                                    $.LoadingOverlay("hide");
                                }, function (err) {
                                    toastr.error($scope.LanguageData.NetworkError);
                                    $.LoadingOverlay("hide");
                                });


                            }
                            $.LoadingOverlay("hide");
                        },
                        function (err) {
                            toastr.error($scope.LanguageData.NetworkError);
                            $.LoadingOverlay("hide");
                        });

                }


            }

            $scope.calcEffDays = function () {

                      $scope.addData.EffectiveDays = addData.DaysAttended ;
                // $scope.addData.EffectiveDays = $scope.addData.DaysAttended + $scope.addData.PaidLeavs +
                //     $scope.addData.WeeklyOff + $scope.addData.Holidays;


            }

            $scope.calculateSalary = function () {
                var totEarnings = 0;
                var totDeductions = 0;

                angular.forEach($scope.addData.EmployeeSalaryDetails, function (a) {
                    if (a.Type == "Earnings") {
                        totEarnings = totEarnings + a.Calculated;
                    } else {
                        totDeductions = totDeductions + a.Calculated;
                    }
                })
                $scope.addData.NetSalary = totEarnings + $scope.addData.HolidayValue + $scope.addData.WeekOffValue;
                $scope.addData.TotalDeductions = totDeductions + $scope.addData.LateHourDeduction;
                $scope.addData.TotalSalary = ($scope.addData.NetSalary + $scope.addData.OvertimeSalary) - $scope.addData.TotalDeductions;

            }




            $scope.SaveData = function () {



                if ($scope.addData.EmployeeId == "") {
                    toastr.warning("Select Employee");
                } else if ($scope.addData.TotalSalary == 0) {
                    toastr.warning("Invalid Salary");
                } else {

                    $scope.addData.DateString = $scope.extractDate($scope.addData.Date);

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.AddEmployeeSalary($scope.addData).then(function (response) {
                        if (response.data) {
                            toastr.success($scope.LanguageData.Success);
                            $scope.Init();
                        } else {
                            toastr.error($scope.LanguageData.NetworkError);
                        }
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        toastr.error($scope.LanguageData.NetworkError);
                        $.LoadingOverlay("hide");
                    });
                }
            }




            $scope.GetBackVoucher = function (type) {
                var temp = 0;
                if ($scope.addData.Id > 0) {
                    temp = $scope.addData.Id;
                }
                $scope.Load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.GetBackEmployeeSalary(temp, type).then(function (response) {
                    if (response.data > 0) {
                        $scope.loadVoucher(response.data);
                    } else {
                        $scope.init();
                    }
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.Load = false;
                    $.LoadingOverlay("hide");
                })
            }

            $scope.Delete = function (data) {
                $('#deleteModal').modal('show');
            }

            $scope.deleteWithConfirm = function () {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteEmployeeSalary($scope.addData.Id).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $('#deleteModal').modal('hide');
                        $state.go("employeeSalary");
                    } else {
                        toastr.warning("Failed");
                    }
                    $.LoadingOverlay("hide");
                    $scope.load = false;
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }






                }])
